import { z } from 'zod';

export const PoolReadinessConfidenceLevel = z
  .enum(['high', 'medium', 'low'])
  .describe('PoolReadinessConfidenceLevel');
export type PoolReadinessConfidenceLevel = z.infer<
  typeof PoolReadinessConfidenceLevel
>;
